import { ConfirmDialog, ConfirmProps } from '@features/confirm-dialog';
import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import { ConfirmContext } from '@shared/libs/context/ConfirmContext';

interface IConfirmProviderProps {
  children: ReactNode;
}

const INITIAL_CONFIRM_STATE: ConfirmProps = {
  isOpen: false,
  header: 'Подтвердите действие',
  message: '',
  okBtnLabel: 'Подтвердить',
  cancelBtnLabel: 'Отмена',
  onConfirm: () => {},
  onCancel: () => {},
};

export const ConfirmProvider: FC<IConfirmProviderProps> = ({ children }) => {
  const [confirmState, setConfirmState] = useState<ConfirmProps>(INITIAL_CONFIRM_STATE);
  const closeConfirmDialog = useCallback(() => {
    setConfirmState((prevState) => ({ ...prevState, isOpen: false }));
  }, []);

  const openConfirmDialog = useCallback(
    (
      message: string | React.ReactNode,
      header = 'Подтвердите действие',
      okBtnLabel = 'Подтвердить',
      cancelBtnLabel = 'Отмена'
    ) => {
      return new Promise((resolve) => {
        setConfirmState({
          isOpen: true,
          header,
          message,
          okBtnLabel,
          cancelBtnLabel,
          onConfirm: () => {
            resolve(true);
            closeConfirmDialog();
          },
          onCancel: () => {
            resolve(false);
            closeConfirmDialog();
          },
        });
      });
    },
    [closeConfirmDialog]
  );

  const contextValue = useMemo(() => ({ openConfirmDialog }), [openConfirmDialog]);

  return (
    <ConfirmContext.Provider value={contextValue}>
      {children}
      {confirmState.isOpen && (
        <ConfirmDialog
          isOpen={confirmState.isOpen}
          header={confirmState.header}
          message={confirmState.message}
          okBtnLabel={confirmState.okBtnLabel}
          cancelBtnLabel={confirmState.cancelBtnLabel}
          onConfirm={confirmState.onConfirm}
          onCancel={confirmState.onCancel}
        />
      )}
    </ConfirmContext.Provider>
  );
};
